import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/image.svg';

export const IconImage = createIconComponent(Icon);
